import {
  RouterProvider as ReactRouterProvider,
  createBrowserRouter,
} from "react-router-dom";

import { routes } from "@/pages/routes";

const router = createBrowserRouter(routes);

export const RouterProvider = () => {
  return <ReactRouterProvider router={router} />;
};
